/**
 * A loading indicator consisting of 3 bouncing dots.
 */
export default {
  title: 'Atoms/Loading',
  tags: ['autodocs'],
  render: () => `<sharpen-loading></sharpen-loading>`,
};

export const Example = {};
